import { Layout } from "antd";
import React from "react";
import Card from "../Card";
import Image from "../Image";

const { Content } = Layout;

type FullScreenModalProps = {
  icon: string;
  onClickIcon: () => void;
  footer: React.ReactNode;
  title: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const FullScreenModal = ({
  icon,
  onClickIcon,
  footer,
  title,
  children,
  style,
}: FullScreenModalProps) => {
  return (
    <Layout className="full_screen__modal">
      <Layout.Header className="full_screen__document__header">
        <Image
          src={icon}
          width="42px"
          preview={false}
          onClick={onClickIcon}
          className="full_screen__modal__icon"
        />
      </Layout.Header>
      <Content>
        <Card
          title={title}
          bordered={true}
          className="full_screen__document__card"
          styles={{ body: style }}
        >
          {children}
        </Card>
      </Content>
      {footer}
    </Layout>
  );
};

export default FullScreenModal;
